import { Node } from '@tiptap/core'
import { sharedAttrs } from '../shared/shared-attrs'

export const RESTRICTED_SECTION_NODE_NAME = 'restricted_section'

function stringAttr(name: string, dataAttribute: string) {
  return {
    default: null,
    parseHTML: (element: HTMLElement) => element.getAttribute(dataAttribute),
    renderHTML: (attrs: Record<string, any>) => (attrs[name] ? { [dataAttribute]: attrs[name] } : {}),
  }
}

/**
 * A leaf mount left in the base document in place of a restricted agenda item's body. It carries no
 * readable content: the item's real minutes live in a separate scope Y.Doc (`minutes:<callId>:scope:<templateItemId>`)
 * that only authorized clients ever connect to. The UI renders a nested editor here for members and a locked
 * placeholder otherwise.
 */
export const RestrictedSection = Node.create({
  name: RESTRICTED_SECTION_NODE_NAME,
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      ...sharedAttrs,
      scopeId: stringAttr('scopeId', 'data-scope-id'),
      templateItemId: stringAttr('templateItemId', 'data-template-item-id'),
      nodeId: stringAttr('nodeId', 'data-node-id'),
      label: stringAttr('label', 'data-label'),
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-type="restricted-section"]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', { ...HTMLAttributes, 'data-type': 'restricted-section' }]
  },
})
